import React from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const ButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
`;

const LoginButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 20px;
  height: 36px;
  border: 1px solid #8d8d8d;
  border-radius: 12px;
  background: transparent;
  color: #ffffff;
  font-family: 'NanumSquareRound', sans-serif;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: -0.32px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
    border-color: #ffffff;
  }
`;

const SignupButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 20px;
  height: 36px;
  border: none;
  border-radius: 12px;
  background: #07d993;
  color: #0d1117;
  font-family: 'NanumSquareRound', sans-serif;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: -0.32px;
  cursor: pointer;
  box-shadow: 0px 12px 30px 0px rgba(7, 217, 147, 0.5);
  transition: all 0.2s;

  &:hover {
    background: #06c585;
    transform: translateY(-1px);
    box-shadow: 0px 14px 35px 0px rgba(7, 217, 147, 0.6);
  }

  &:active {
    transform: translateY(0);
  }
`;

const AuthButtons: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleLoginClick = () => {
    navigate("/login");
  };

  const handleSignupClick = () => {
    navigate("/signup");
  };

  return (
    <ButtonsContainer>
      <LoginButton onClick={handleLoginClick}>{t("Login")}</LoginButton>
      <SignupButton onClick={handleSignupClick}>{t("Sign up")}</SignupButton>
    </ButtonsContainer>
  );
};

export default AuthButtons;
